import { useMemo, useState } from "react"
import styles from "./index.module.scss"

const DropDownWithCheckbox = ({ dropDownData = {} }) => {

  const normalized = useMemo(() => {
    if (!dropDownData) return null

    return {
      dropdownProps: {
        id: dropDownData.id || "country",
        name: dropDownData.name || "country",
        label: dropDownData.label || "",
        options: Array.isArray(dropDownData.dropDownOptions)
          ? dropDownData.dropDownOptions.map((item, index) => ({
              value: item?.fields?.option?.trim() || "",
              label: item?.fields?.option?.trim() || "",
              disabled: index === 0, // "Select"
            }))
          : [],
      },

      checkboxes: Array.isArray(dropDownData.checkboxes)
        ? dropDownData.checkboxes.map(item => ({
            id: item?.fields?.id,
            text: item?.fields?.text,
            className: item?.fields?.className || "",
            disabled: !!item?.fields?.disabled,
          }))
        : [],
    }
  }, [dropDownData])

  if (!normalized) return null

  const { dropdownProps, checkboxes } = normalized

  const [selectedCountry, setSelectedCountry] = useState("")
  const [selectedId, setSelectedId] = useState(
    checkboxes.find(cb => !cb.disabled)?.id || ""
  )

  return (
    <div className={styles.wrapper}>
      <div className="koh-projects-form">
        {dropdownProps.label && (
          <div className="koh-filter-title">
            <label htmlFor={dropdownProps.id}>
              {dropdownProps.label}
            </label>
          </div>
        )}
        <div className="koh-country select">
          <select
            id={dropdownProps.id}
            name={dropdownProps.name}
            value={selectedCountry}
            onChange={e => setSelectedCountry(e.target.value)}
          >
            {dropdownProps.options.map(opt => (
              <option
                key={opt.value}
                value={opt.value}
                disabled={opt.disabled}
              >
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        <div className="koh-demo-filter">
          {checkboxes.map(cb => {
            if (!cb.id || !cb.text) return null

            return (
              <span
                key={cb.id}
                className={cb.disabled ? "is-disabled" : ""}
              >
                <input
                  id={cb.id}
                  type="checkbox"
                  className={cb.className}
                  checked={selectedId === cb.id}
                  disabled={cb.disabled}
                  onChange={() => setSelectedId(cb.id)}
                />
                <label htmlFor={cb.id}>{cb.text}</label>
              </span>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default DropDownWithCheckbox
